<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/tama_9781571318879_oeb_als_r1">ALSO BY TAMAS DOBOZY</a></div>
<div class="cfmh"><span href="#/tama_9781571318879_oeb_tp_r1" title="Link target outside of Sample">Title Page</span></div>
<div class="cfmh"><a href="#/tama_9781571318879_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/tama_9781571318879_oeb_epi_r1">Epigraph</a></div>
<div> <br/></div>
<div class="cct"><a href="#/tama_9781571318879_oeb_c01_r1">The Atlas of B. Görbe</a></div>
<div> <br/></div>
<div class="cct"><a href="#/tama_9781571318879_oeb_c02_r1">The Animals of the Budapest Zoo, 1944–1945</a></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c03_r1" title="Link target outside of Sample">Sailor’s Mouth</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c04_r1" title="Link target outside of Sample">The Restoration of the Villa Where Tíbor Kálmán Once Lived</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c05_r1" title="Link target outside of Sample">The Beautician</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h1" title="Link target outside of Sample">1.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h2" title="Link target outside of Sample">2.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h3" title="Link target outside of Sample">3.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h4" title="Link target outside of Sample">4.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h5" title="Link target outside of Sample">5.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h6" title="Link target outside of Sample">6.</span></div>
<div class="ch1"><span href="#/tama_9781571318879_oeb_c05_r1#h7" title="Link target outside of Sample">7.</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c06_r1" title="Link target outside of Sample">Days of Orphans and Strangers</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c07_r1" title="Link target outside of Sample">Rosewood Queens</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c08_r1" title="Link target outside of Sample">The Encirclement</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c09_r1" title="Link target outside of Sample">The Society of Friends</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c10_r1" title="Link target outside of Sample">The Miracles of Saint Marx</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c11_r1" title="Link target outside of Sample">The Selected Mug Shots of Famous Hungarian Assassins</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c12_r1" title="Link target outside of Sample">The Ghosts of Budapest and Toronto</span></div>
<div> <br/></div>
<div class="cct"><span href="#/tama_9781571318879_oeb_c13_r1" title="Link target outside of Sample">The Homemade Doomsday Machine</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/tama_9781571318879_oeb_ack_r1" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="cbmh"><span href="#/tama_9781571318879_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tama_9781571318879_oeb_toc_r1.vue?ab960236